export default [
    {
        path: '/payouts',
        name: 'payouts',
        meta: { layout: 'dashboard' },
        component: () => import('VIEWS/Finance/Payouts.vue')
    }
]
